import { styled } from '@linaria/react';

export const SocialAuthSubmitSpin = styled.div`
  display: flex;
  justify-content: center;
  & svg {
    fill: var(--bb-field-placeholder);
  }
`;

export const SocialAuthButtonSpin = styled.div`
  display: flex;
  justify-content: center;
  & svg {
    fill: var(--bb-icon-color);
  }
`;

export const Divider = styled.div`
  position: relative;
  text-align: center;
  color: var(--bb-oauth-divider-color);
  margin: 16px 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 42%;
    height: 1px;
    background-color: var(--bb-oauth-divider-background-color);
    top: 50%;
    left: 0;
  }

  &::after {
    left: auto;
    right: 0;
  }
`;

export const ProviderContainer = styled.div<{ isSmall: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ isSmall }) => (isSmall ? '16px' : '8px')};
  margin-bottom: ${({ isSmall }) => (isSmall ? '16px' : 0)};
`;

export const ProviderRow = styled.div<{ isSmall: boolean }>`
  flex-grow: 1;
`;

export const ProviderButton = styled.button<{ isUsed: boolean; isSmall: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ isUsed }) =>
    isUsed
      ? 'var(--bb-oauth-button-background-color-used)'
      : 'var(--bb-oauth-button-background-color)'};
  border: 1px solid transparent;
  border-color: ${({ isUsed }) =>
    isUsed ? 'var(--bb-oauth-button-border-color-used)' : 'var(--bb-oauth-button-border-color)'};
  border-radius: var(--bb-oauth-button-border-radius);
  padding: ${({ isSmall }) => (isSmall ? '13px' : '12px 22px')};
  font-size: 16px;
  font-family: inherit;
  font-weight: 700;
  color: #424242;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
    background-color: var(--bb-oauth-button-background-color-used);
    border-color: #ad8200;
  }
`;

export const ProviderButtonText = styled.span`
  display: blockr;
  margin-left: 8px;
`;

export const ProviderUsedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  @media (max-width: 375px) {
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ProviderUsedText = styled.div`
  color: #424242;
  text-align: center;
  font-size: 14px;
`;

export const ArrowIconGoogle = styled.div<{ isSmall: boolean }>`
  margin-right: 8px;
  transform: ${({ isSmall }) => `scaleX(-1) ${isSmall ? 'rotate(-30deg)' : ''}`};
`;

export const ArrowIconApple = styled.div<{ isSmall: boolean }>`
  margin-left: 8px;
  transform: ${({ isSmall }) => (isSmall ? 'rotate(-65deg)' : '')};
`;

export const UsedProviderRow = styled.div<{ second: boolean }>`
  position: relative;
  min-height: 45px;
  min-width: 100%;
  overflow: visible;
  & > div {
    position: absolute;
    min-width: max-content;
    flex-wrap: nowrap;
    left: ${({ second }) => (second ? '50%' : '0')};
  }
`;

export const PolicyModalContent = styled.div`
  max-width: 400px;
`;

export const PolicyButtonContainer = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: center;
`;

export const PolicyButtonWrapper = styled.div`
  min-width: 50%;
`;

export const AuthTooltipContainer = styled.div`
  box-sizing: border-box;
  padding-bottom: 8px;
  padding-top: 8px;
  z-index: -1;
  visibility: hidden;

  &.active {
    z-index: 10;
    visibility: visible;
  }
`;

export const AuthTooltip = styled.div`
  max-width: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.82);
  font-size: 14px;
  color: #fff;
  border-radius: 3px;
`;
